import { render, staticRenderFns } from "./IconMedium.vue?vue&type=template&id=39b1ea36&"
import script from "./IconMedium.vue?vue&type=script&lang=js&"
export * from "./IconMedium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports